export const PATH_TO_VIEWER = '/pdf/web/viewer.html';
